import PropTypes from 'prop-types'
import { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useLazyQuery } from '@apollo/client'
import { GET_TRIP_TYPE } from 'graphql/route/queries'

export function TripTypeDropdown({ fields, onChangeData, disabled = false }) {
    const { t } = useTranslation()

    const [tripTypeList, setTripTypeList] = useState([])

    const [getTripTypeList, { loading: tripTypeLoading, error: tripTypeError }] = useLazyQuery(
        GET_TRIP_TYPE,
        {
            fetchPolicy: 'network-only',
            notifyOnNetworkStatusChange: true,
            onCompleted: data => {
                if (data.tripType) {
                    // The API returns a single type or all types when code is null
                    // Wrap in array if single object returned
                    const types = Array.isArray(data.tripType) 
                        ? data.tripType 
                        : [data.tripType]
                    setTripTypeList(types.filter(type => type !== null))
                }
            },
        }
    )

    // Get Trip Type List
    const getTripTypes = () => {
        getTripTypeList({
            variables: {
                code: null,
            },
        })
    }

    useEffect(() => {
        getTripTypes()
    }, [])

    const onChangeHandler = e => {
        console.log('Trip Type selected--', e.target.value)
        // Set the value to the form
        fields.onChange(e)
        // Find the selected item
        const selectedItem = tripTypeList.find(item => item.code === e.target.value)
        console.log('Selected Trip Type--', selectedItem)
        if (selectedItem && onChangeData) {
            onChangeData(selectedItem)
        }
    }

    return (
        <>
            {tripTypeLoading && <div className="flex justify-center items-center bg-white py-5">{t('Loading')} ....</div>}
            {tripTypeError && (
                <div className="flex justify-center items-center bg-white py-5">
                    <div className="text-lg text-center">{t('Failed to fetch trip types')}</div>
                </div>
            )}
            {!tripTypeLoading && !tripTypeError && tripTypeList?.length === 0 && (
                <div className="flex justify-center items-center bg-white py-5">
                    <div className="text-lg text-center">{t('No trip types found!')}</div>
                </div>
            )}
            {!tripTypeLoading && !tripTypeError && tripTypeList?.length > 0 && (
                <select
                    {...fields}
                    disabled={disabled}
                    onChange={onChangeHandler}
                    className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-primary sm:max-w-full sm:text-sm sm:leading-6 disabled:bg-gray-100 disabled:cursor-not-allowed"
                >
                    <option value="">{t('Select a Trip Type')}</option>
                    {tripTypeList.map(type => (
                        <option key={type.code} value={type.code}>
                            {type.description?.en || type.code}
                        </option>
                    ))}
                </select>
            )}
        </>
    )
}

TripTypeDropdown.propTypes = {
    fields: PropTypes.object.isRequired,
    onChangeData: PropTypes.func,
    disabled: PropTypes.bool,
}
